// `APP` is deliberately a small mutable configuration singleton.  React
// components that need to respond to an explicit town change subscribe here
// rather than trying to observe the singleton directly.
const listeners = new Set();

export const onZoneChange = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const emitZoneChange = (zone) => {
  listeners.forEach((listener) => {
    try {
      listener(zone);
    } catch (error) {
      // One stale UI listener must never prevent the rest of the app from
      // receiving an otherwise valid service-zone update.
      console.warn('zone change listener failed:', error);
    }
  });
};
